<script setup lang="ts">
import { reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { useAuthStore } from '@/stores/authStore.ts';
import CardComponent from '@/components/ui/CardComponent.vue';

import type { OTPRequest } from "@/types/services/auth/auth.type.ts";
import AppLogoComponent from '@/components/ui/AppLogoComponent.vue';

const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()

//--- Define page content ---//
const loading = ref<boolean>(false)

//--- Login form ---//
const codeLength = ref<number>(6)
const form = reactive({
  otpSecret: ''
})
const email = ref<string>((router.currentRoute.value.query.email as string) || '')

async function submit2fa(): Promise<void> {
  loading.value = true

  const user: OTPRequest = {
    email: email.value,
    otpSecret: form.otpSecret
  }

  try {
    await authStore.loginOTP(user)
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <v-container fluid class="h-screen w-full d-flex justify-center align-center">
    <CardComponent>
      <template #title>
        <div class="d-flex align-center justify-center my-4">
          <AppLogoComponent />
        </div>
      </template>
      <template #item>
				<v-row>
					<v-col cols="auto">
						<RouterLink to="/login" class="d-flex align-center">
							<v-icon icon="PhArrowLeft" size="medium" class="mr-1" />
							{{ t('common.buttons.back') }}
						</RouterLink>
					</v-col>
					<v-col cols="12">
						<h3>{{ t('views.loginOtp.title') }}</h3>
					</v-col>
          <v-col cols="12">
            <p class="mb-4">{{ t('views.loginOtp.description') }}</p>
          </v-col>
				</v-row>
        <v-form @submit.prevent="submit2fa">
          <v-row class="py-1">
            <v-col cols="12">
              <v-otp-input
                v-model="form.otpSecret"
                :length="codeLength"
                autocomplete="one-time-code"
                autofocus
                hide-details="auto"
                variant="solo"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
							<v-btn
                :disabled="form.otpSecret.length !== codeLength || loading"
                :loading="loading"
                block
                type="submit"
              >
								{{ t('common.buttons.submit') }}
								<template #append>
									<v-icon icon="PhSignIn"/>
								</template>
							</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </template>
    </CardComponent>
	</v-container>
</template>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
